/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// reactstrap components
/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import api from "api";
import { Store, UpdateStore } from "StoreContext";
import {
  Card,
  CardHeader,
  Media,
  Table,
  Container,
  Row,
  CardFooter,
  Input,
  Label,
} from "reactstrap";
import moment from "moment";
import Spinner from "components/Spinner/Spinner";
import { MenuItem, Pagination, PaginationItem, Select } from "@mui/material";
import ArrowBack from "../../assets/LeftArrow.svg";
import ArrowForward from "../../assets/RIghtArrow.svg";
import DatePicker from "react-datepicker";
import CalenderIcon from "../../assets/Calendar-Icon.svg";
import "react-datepicker/dist/react-datepicker.css";

import SearchComp from "components/searchComp";
import SearchBar from "components/Common/SearchBar";
import { ReactComponent as Arrow } from "../../assets/img/Arrowdown.svg"

const TAB_SCAN = "scan";
const TAB_ACCOUNT = "account";

const tabStyles = {
  container: {
    display: "flex",
    gap: "0px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },
  tab: (isActive) => ({
    padding: "10px 24px",
    cursor: "pointer",
    fontFamily: "Outfit",
    fontWeight: 600,
    fontSize: "14px",
    color: isActive ? "#ffffff" : "#362FD8",
    backgroundColor: isActive ? "#362FD8" : "#ffffff",
    border: "1px solid #362FD8",
    borderRadius: "0px",
    transition: "all 0.2s ease",
  }),
  tabFirst: {
    borderTopLeftRadius: "8px",
    borderBottomLeftRadius: "8px",
  },
  tabLast: {
    borderTopRightRadius: "8px",
    borderBottomRightRadius: "8px",
    borderLeft: "none",
  },
};

const getActivityColor = (activity) => {
  if (activity?.includes('Valid') && !activity?.includes('Invalid')) {
    return { bg: '#059669', rowBg: '#ecfdf5' };
  }
  if (activity?.includes('Invalid')) {
    return { bg: '#dc2626', rowBg: '#fef2f2' };
  }
  if (activity?.includes('Repeat')) {
    return { bg: '#d97706', rowBg: '#fffbeb' };
  }
  if (activity?.includes('Points Allocated')) {
    return { bg: '#7c3aed', rowBg: '#f5f3ff' };
  }
  if (activity?.includes('Redeemed') || activity?.includes('Redemption Fulfilled')) {
    return { bg: '#0891b2', rowBg: '#ecfeff' };
  }
  if (activity?.includes('Redemption Failed')) {
    return { bg: '#dc2626', rowBg: '#fef2f2' };
  }
  if (activity?.includes('Login')) {
    if (activity?.toLowerCase().includes('failed') || activity?.toLowerCase().includes('fail')) {
      return { bg: '#dc2626', rowBg: '#fef2f2' };
    }
    return { bg: '#362FD8', rowBg: '#eef2ff' };
  }
  if (activity?.includes('Password') || activity?.includes('Brand') || activity?.includes('Registration')) {
    return { bg: '#6366f1', rowBg: '#eef2ff' };
  }
  return { bg: '#6b7280', rowBg: '#f9fafb' };
};

const formatIp = (ip) => {
  if (ip === '::1' || ip === '127.0.0.1') return 'localhost';
  return ip || 'N/A';
};

// Auth logs carry the raw User-Agent string (often 120+ chars), which used
// to spill out of the desktop "Details" column. Collapse to "Browser on OS".
const prettyUserAgent = (ua) => {
  if (!ua || typeof ua !== 'string' || ua === 'unknown') return ua || 'unknown';
  let browser = 'Browser';
  if (/Edg\//.test(ua)) browser = 'Edge';
  else if (/OPR\/|Opera/.test(ua)) browser = 'Opera';
  else if (/Chrome\//.test(ua) && !/Chromium/.test(ua)) browser = 'Chrome';
  else if (/Firefox\//.test(ua)) browser = 'Firefox';
  else if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) browser = 'Safari';
  let os = '';
  if (/Windows NT/.test(ua)) os = 'Windows';
  else if (/iPhone|iPad/.test(ua)) os = 'iOS';
  else if (/Mac OS X|Macintosh/.test(ua)) os = 'macOS';
  else if (/Android/.test(ua)) os = 'Android';
  else if (/Linux/.test(ua)) os = 'Linux';
  return os ? `${browser} on ${os}` : browser;
};

const getDetailFields = (item) => {
  const meta = item.metadata;
  if (meta && typeof meta === 'object' && Object.keys(meta).length > 0) {
    return meta;
  }
  return null;
};

const getSummaryLine = (item) => {
  const meta = item.metadata;
  if (meta && typeof meta === 'object') {
    if (meta.brandName && meta.code) return `${meta.brandName} - ${meta.code}`;
    if (meta.brandName && meta.productName) return `${meta.brandName} - ${meta.productName}`;
    if (meta.email && meta.action) return `${meta.email} - ${meta.action}`;
    if (meta.brandName) return meta.brandName;
    if (meta.email) return meta.email;
  }
  return (typeof item.description === 'object' ? JSON.stringify(item.description) : item.description) || '';
};

const getDetailsContent = (item) => {
  const meta = item.metadata;
  const activity = item.emailType || '';
  const pairs = [];

  if (meta && typeof meta === 'object' && Object.keys(meta).length > 0) {
    const isScan = activity.includes('Valid') || activity.includes('Invalid') || activity.includes('Repeat') || activity.includes('Scan');
    const isReward = activity.includes('Points') || activity.includes('Redeem') || activity.includes('Redemption');

    if (isScan) {
      if (meta.code || meta.codeEntered) pairs.push({ label: 'Code', value: meta.code || meta.codeEntered });
      if (meta.brandName) pairs.push({ label: 'Brand', value: meta.brandName });
      if (meta.batchName || meta.productName) {
        const batchLabel = meta.batchId ? `${meta.batchName || meta.productName} (#${meta.batchId})` : (meta.batchName || meta.productName);
        pairs.push({ label: 'Batch', value: batchLabel });
      }
      if (meta.location && (meta.location.city || meta.location.region || meta.location.country)) {
        const loc = [meta.location.city, meta.location.region, meta.location.country].filter(Boolean).join(', ');
        pairs.push({ label: 'Location', value: loc });
      }
      if (meta.scanAttempts) pairs.push({ label: 'Attempts', value: meta.scanAttempts });
      if (meta.origin && meta.origin !== 'direct') pairs.push({ label: 'Source', value: meta.origin.replace(/^https?:\/\//, '') });
    } else if (isReward) {
      if (meta.points) pairs.push({ label: 'Points', value: meta.points });
      if (meta.productName) pairs.push({ label: 'Product', value: meta.productName });
      if (meta.brandName) pairs.push({ label: 'Brand', value: meta.brandName });
    } else {
      if (meta.email) pairs.push({ label: 'Email', value: meta.email });
      if (meta.action || meta.result) pairs.push({ label: 'Result', value: meta.action || meta.result });
    }

    // Add any remaining meta keys not already shown
    const shownKeys = new Set(['code', 'codeEntered', 'brandName', 'brandId', 'batchId', 'batchName', 'productName', 'scanAttempts', 'points', 'email', 'action', 'result', 'origin', 'location', 'codeType']);
    Object.entries(meta).forEach(([key, value]) => {
      if (!shownKeys.has(key) && value !== null && value !== undefined && value !== '') {
        const display = key === 'userAgent'
          ? prettyUserAgent(String(value))
          : formatMetaValue(value);
        if (display) {
          pairs.push({
            label: key === 'userAgent'
              ? 'Device'
              : key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
            value: display,
          });
        }
      }
    });
  }

  return pairs;
};

// Recursively render a metadata value for display. The naive `String(value)`
// returns "[object Object]" for objects (e.g. metadata.location which is
// { city, region, country }). This walks objects + arrays and joins their
// non-empty values with commas — so { city: 'Irvine', region: 'CA' } reads
// as "Irvine, CA". Nested objects are flattened the same way.
const formatMetaValue = (v) => {
  if (v === null || v === undefined) return '';
  if (typeof v !== 'object') return String(v);
  if (Array.isArray(v)) {
    return v
      .filter((x) => x !== null && x !== undefined && x !== '')
      .map(formatMetaValue)
      .join(', ');
  }
  return Object.values(v)
    .filter((x) => x !== null && x !== undefined && x !== '')
    .map(formatMetaValue)
    .join(', ');
};

const getModalFields = (item) => {
  const fields = [];
  const meta = item.metadata;
  const activity = item.emailType || '';

  // Activity badge handled separately
  if (meta && typeof meta === 'object') {
    if (meta.code) fields.push({ label: 'Code', value: meta.code });
    if (meta.brandName) fields.push({ label: 'Brand Name', value: meta.brandName });
    if (meta.batchName || meta.productName) fields.push({ label: 'Product / Batch', value: meta.batchName || meta.productName });
    if (meta.scanAttempts) fields.push({ label: 'Scan Attempts', value: meta.scanAttempts });
    if (meta.points) fields.push({ label: 'Reward Points', value: meta.points });

    const shownKeys = new Set(['code', 'brandName', 'batchName', 'productName', 'scanAttempts', 'points']);
    Object.entries(meta).forEach(([key, value]) => {
      if (!shownKeys.has(key) && value !== null && value !== undefined && value !== '') {
        const display = key === 'userAgent'
          ? prettyUserAgent(String(value))
          : formatMetaValue(value);
        if (display) {
          fields.push({
            label: key === 'userAgent'
              ? 'Device'
              : key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
            value: display,
          });
        }
      }
    });
  }

  fields.push({ label: 'IP Address', value: formatIp(item.ip) });
  fields.push({ label: 'Timestamp', value: moment(item.createdAt).format('MMM DD, YYYY hh:mm:ss A') });
  if (item.description) fields.push({ label: 'Description', value: typeof item.description === 'object' ? JSON.stringify(item.description) : item.description });

  return fields;
};

const thStyle = {
  borderTop: 'none',
  background: 'white',
  fontSize: '16px',
  fontWeight: 600,
  color: '#1C1C1C',
  textTransform: 'capitalize',
  letterSpacing: 0,
};

const UserLogs = () => {
  const pageSize = 20;
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const updateStore = UpdateStore();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filterLogs, setFilterLogs] = useState([]);
  const [search, setSearch] = useState();
  const [activeTab, setActiveTab] = useState(TAB_SCAN);
  const [selectedLog, setSelectedLog] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);
  const sentinelRef = useRef(null);

  const handleStartDate = (date) => {
    setStartDate(date);
  };

  const handleEndDate = (date) => {
    setEndDate(date);
  };

  const getUserLogs = async (pageNum, append) => {
    if (loading) return;
    try {
      let queryUrl = `/logs/userlogs?page=${pageNum}&pageSize=${pageSize}&type=${activeTab}`;
      const queryParams = [];
      if (startDate) queryParams.push(`startDate=${startDate}`);
      if (endDate) queryParams.push(`endDate=${endDate}`);
      if (queryParams.length > 0) {
        queryUrl += `&${queryParams.join("&")}`;
      }
      setLoading(true);
      const data = await api("get", queryUrl);
      const newLogs = data.userLogs || [];

      if (append) {
        setFilterLogs(prev => [...prev, ...newLogs]);
      } else {
        setFilterLogs(newLogs);
      }

      setHasMore(newLogs.length >= pageSize);
      updateStore({
        userLogs: append ? [...filterLogs, ...newLogs] : newLogs,
        userTotalRecords: data.totalRecords,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setSearch(e.target.value)
  }

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setPage(1);
    setHasMore(true);
    setSearch(undefined);
    setExpandedCards({});
    setFilterLogs([]);
  };

  // Initial load + reload on filter/tab change
  useEffect(() => {
    getUserLogs(page, page > 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, startDate, endDate, activeTab]);

  // Reset to page 1 when tab or dates change
  useEffect(() => {
    setPage(1);
    setHasMore(true);
    setFilterLogs([]);
  }, [activeTab, startDate, endDate]);

  // Infinite scroll via IntersectionObserver
  useEffect(() => {
    if (!sentinelRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !loading) {
          setPage(p => p + 1);
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [hasMore, loading]);

  // Client-side search filter — operates on the already-loaded filterLogs
  const [allLogs, setAllLogs] = useState([]);
  useEffect(() => {
    if (!search) setAllLogs(filterLogs);
  }, [filterLogs]);

  useEffect(() => {
    if (search) {
      const filtered = allLogs?.filter(item =>
        item?.emailType?.toLowerCase().includes(search.toLowerCase())
      );
      setFilterLogs(filtered);
    } else {
      setFilterLogs(allLogs);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <>
      <Container fluid>
        {loading && <Spinner />}
        <div className='d-flex justify-content-between align-items-center '>
          <h1 className="vs-page-title">User Logs</h1>
        </div>
        <div style={tabStyles.container}>
          <div
            style={{ ...tabStyles.tab(activeTab === TAB_SCAN), ...tabStyles.tabFirst }}
            onClick={() => handleTabChange(TAB_SCAN)}
          >
            Scan &amp; Reward Logs
          </div>
          <div
            style={{ ...tabStyles.tab(activeTab === TAB_ACCOUNT), ...tabStyles.tabLast }}
            onClick={() => handleTabChange(TAB_ACCOUNT)}
          >
            Account Logs
          </div>
        </div>
        <div className="d-flex flex-wrap flex-sm-nowrap align-items-end pb-4" style={{
          gap: "10px"
        }}>
          <SearchBar handleChange={handleChange} />
          <div className="startdate-input-1">
            <label
              style={{
                fontFamily: 'Outfit',
                fontWeight: 600,
                fontSize: '16px',
                color: "#1c1c1c"
              }}
            >Start Date</label>
            <div className="input-div">
              <DatePicker
                id="start-date-picker"
                selected={startDate}
                onChange={(date) => handleStartDate(date)}
                dateFormat="MM/dd/yyyy"
                placeholderText="mm/dd/yyyy"
                className="custom-datepicker"
                popperClassName="custom-datepicker-pooper"
              />
              <img
                src={CalenderIcon}
                alt="calendar icon"
                onClick={() =>
                  document.getElementById("start-date-picker").focus()
                }
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
          <div className="startdate-input-1">
            <label style={{
              fontFamily: 'Outfit',
              fontWeight: 600,
              fontSize: '16px',
              color: "#1c1c1c"
            }}>End Date</label>
            <div className="input-div">
              <DatePicker
                id="end-date-picker"
                selected={endDate}
                onChange={(date) => handleEndDate(date)}
                dateFormat="MM/dd/yyyy"
                placeholderText="mm/dd/yyyy"
                className="custom-datepicker"
                popperClassName="custom-datepicker-pooper"
              />
              <img
                src={CalenderIcon}
                alt="calendar icon"
                onClick={() =>
                  document.getElementById("end-date-picker").focus()
                }
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>

        {/* Desktop table - hidden on mobile */}
        <Row className="d-none d-md-flex">
          <div className='col'>
            <Table style={{ fontFamily: 'Outfit' }} className='align-items-center table-flush' responsive>
              <thead className='thead-light'>
                <tr>
                  <th style={{ ...thStyle, borderTopLeftRadius: '10px' }} scope='col'>Activity</th>
                  <th style={thStyle} scope='col'>Details</th>
                  <th style={thStyle} scope='col'>IP</th>
                  <th style={{ ...thStyle, borderTopRightRadius: '10px' }} scope='col'>Time</th>
                </tr>
              </thead>
              <tbody>
                {filterLogs?.length ? filterLogs?.map((item, index) => {
                  const colors = getActivityColor(item.emailType);
                  const detailPairs = getDetailsContent(item);
                  const isLast = index === filterLogs.length - 1;

                  return (
                    <tr
                      key={item._id || index}
                      style={{
                        fontFamily: "Outfit",
                        color: '#1C1C1C',
                        cursor: 'pointer',
                        borderLeft: `4px solid ${colors.bg}`,
                        transition: 'background-color 0.15s ease',
                      }}
                      className='bg-white'
                      onClick={() => { setSelectedLog(item); setDetailOpen(true); }}
                      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = colors.rowBg; }}
                      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = ''; }}
                    >
                      <td style={{
                        borderBottomLeftRadius: isLast ? '10px' : '0px',
                        verticalAlign: 'middle',
                      }}>
                        <span style={{
                          display: 'inline-block',
                          padding: '4px 10px',
                          borderRadius: '6px',
                          backgroundColor: colors.bg,
                          color: '#fff',
                          fontSize: '12px',
                          fontWeight: 600,
                          whiteSpace: 'nowrap',
                          lineHeight: '1.4',
                        }}>
                          {item.emailType}
                        </span>
                      </td>
                      <td style={{ verticalAlign: 'middle', width: '340px', maxWidth: '340px' }}>
                        {detailPairs.length > 0 ? (
                          <div style={{ lineHeight: '1.5', maxWidth: '100%' }}>
                            {detailPairs.slice(0, 3).map((pair, i) => (
                              <div
                                key={i}
                                style={{
                                  fontSize: '13px',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '100%',
                                }}
                                title={`${pair.label}: ${pair.value}`}
                              >
                                <span style={{ color: '#9ca3af', fontWeight: 500 }}>{pair.label}: </span>
                                <span style={{ color: '#374151' }}>{pair.value}</span>
                              </div>
                            ))}
                            {detailPairs.length > 3 && (
                              <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '2px' }}>
                                +{detailPairs.length - 3} more fields
                              </div>
                            )}
                          </div>
                        ) : (
                          <span
                            style={{
                              fontSize: '13px',
                              color: '#6b7280',
                              display: 'block',
                              maxWidth: '100%',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                            title={typeof item.description === 'object' ? JSON.stringify(item.description) : item.description}
                          >
                            {(typeof item.description === 'object' ? JSON.stringify(item.description) : item.description) || 'No details available'}
                          </span>
                        )}
                      </td>
                      <td style={{ verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
                        <span style={{ fontSize: '13px', color: '#374151' }}>
                          {formatIp(item.ip)}
                        </span>
                      </td>
                      <td
                        style={{
                          borderBottomRightRadius: isLast ? '10px' : '0px',
                          whiteSpace: 'nowrap',
                          verticalAlign: 'middle',
                        }}
                        title={moment(item.createdAt).format('MMM DD, YYYY hh:mm:ss A')}
                      >
                        <span style={{ fontSize: '13px', color: '#374151' }}>
                          {moment(item.createdAt).fromNow()}
                        </span>
                      </td>
                    </tr>
                  )
                }) : <tr><td colSpan={4} style={{ textAlign: 'center', fontFamily: 'Outfit', padding: '24px' }}>No Data Found</td></tr>}
              </tbody>
            </Table>
          </div>
        </Row>

        {/* Mobile card view - shown only on mobile */}
        <div className="d-block d-md-none" style={{ backgroundColor: '#fff', borderRadius: '10px', overflow: 'hidden' }}>
          {filterLogs?.length ? filterLogs.map((item) => {
            const colors = getActivityColor(item.emailType);
            const summary = getSummaryLine(item);

            return (
              <div key={item._id} style={{
                padding: '12px 16px',
                borderBottom: '1px solid #f0f0f0',
                borderLeft: `4px solid ${colors.bg}`,
                cursor: 'pointer',
              }} onClick={() => { setSelectedLog(item); setDetailOpen(true); }}>
                {/* First line: badge + relative time */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                  <span style={{
                    fontSize: '11px',
                    fontWeight: 600,
                    padding: '2px 8px',
                    borderRadius: '4px',
                    backgroundColor: colors.bg,
                    color: '#fff',
                    whiteSpace: 'nowrap',
                  }}>
                    {item.emailType}
                  </span>
                  <span style={{ fontSize: '12px', color: '#999' }}>
                    {moment(item.createdAt).fromNow()}
                  </span>
                </div>

                {/* Summary line */}
                <p style={{
                  fontSize: '13px',
                  color: '#333',
                  margin: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontFamily: 'Outfit',
                }}>
                  {summary}
                </p>
              </div>
            );
          }) : <div style={{ padding: '16px', textAlign: 'center', fontFamily: 'Outfit' }}>No Data Found</div>}
        </div>

        {/* Detail Modal (desktop click) */}
        {detailOpen && selectedLog && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1050,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            }}
            onClick={() => setDetailOpen(false)}
          >
            <div
              style={{
                backgroundColor: '#fff',
                borderRadius: '16px',
                padding: '24px',
                width: '90%',
                maxWidth: '440px',
                maxHeight: '80vh',
                overflowY: 'auto',
                position: 'relative',
                fontFamily: 'Outfit',
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 600, fontFamily: 'Outfit' }}>Log Details</h3>
                <button
                  onClick={() => setDetailOpen(false)}
                  style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#999', lineHeight: 1 }}
                >
                  &times;
                </button>
              </div>
              <div style={{ fontSize: '14px' }}>
                {/* Activity badge */}
                <div style={{ marginBottom: '14px' }}>
                  <label style={{ fontWeight: 600, color: '#888', fontSize: '12px', display: 'block', marginBottom: '4px' }}>Activity</label>
                  <span style={{
                    padding: '4px 10px',
                    borderRadius: '6px',
                    backgroundColor: getActivityColor(selectedLog.emailType).bg,
                    color: '#fff',
                    fontSize: '12px',
                    fontWeight: 600,
                  }}>
                    {selectedLog.emailType}
                  </span>
                </div>

                {/* All metadata fields */}
                {getModalFields(selectedLog).map((field, i) => (
                  <div key={i} style={{ marginBottom: '12px' }}>
                    <label style={{ fontWeight: 600, color: '#888', fontSize: '12px', display: 'block', marginBottom: '2px' }}>{field.label}</label>
                    <span style={{ color: '#1C1C1C' }}>{field.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Infinite scroll sentinel + loading indicator */}
        <div ref={sentinelRef} style={{ height: '1px' }} />
        {loading && (
          <div style={{ textAlign: 'center', padding: '16px', fontFamily: 'Outfit', color: '#888', fontSize: '13px' }}>
            Loading more...
          </div>
        )}
        {!hasMore && filterLogs.length > 0 && (
          <div style={{ textAlign: 'center', padding: '12px', fontFamily: 'Outfit', color: '#aaa', fontSize: '12px' }}>
            All logs loaded
          </div>
        )}
      </Container>
    </>
  );
};

export default UserLogs;
